import WordBusiness from "@/business/WordBusiness";

const path = 'api/tree';

export default {

    async generateGenealogyTreeDocx(protocolId, fileName){
        const url = `${path}/tree/docx/generate/protocol/${protocolId}`;
        return await WordBusiness.showWord(url, null, fileName, 'GET');
    }
}
